import styled from 'styled-components'

import theme, {media} from '@/src/config/theme'

import {CollapseUI} from '@/src/(pages)/profile/ui/collapsable-info'
import * as OrdersUI from '@/src/(pages)/profile/ui/orders.styled'

export const BasketContent = styled(CollapseUI.ListItemContent)`
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: column;
  gap: 60px;
  justify-content: center;

  & > * {
    width: unset;
  }

  @media ${media.md} {
    flex-flow: row;
  }
`

export const ProductList = styled.div`
  flex: 1;

  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 5px;

  @media ${media.lg} {
    display: grid;
    grid-template-columns: repeat(6, minmax(max-content, 1fr));
    grid-template-rows: 1fr;
  }
`

export const ProductRow = styled(OrdersUI.ProductRow)`
  position: relative;
  align-items: center;
  flex-direction: column;
  border: solid 1px ${theme.colors.borderColor};
  padding: 20px;
  gap: 10px;
  max-width: 320px;

  @media ${media.lg} {
    padding: unset;
    border: unset;
    max-width: unset;
    flex-direction: row;

    display: grid;
    grid-column: 1/8;
    grid-template-columns: subgrid;

    & > *:not(:first-child) {
      text-align: center;
    }
  }

  &[data-available="-"] {
    opacity: 0.5;
  }
`
export const ProductContent = styled(OrdersUI.ProductContent)`
  display: flex;
  flex-direction: column;
  gap: 5px;

  align-items: baseline;
  
  text-align: unset !important;
  
  max-width: 450px;
`
export const ProductChangeCount = styled.div`
  font-size: 1rem;

  @media ${media.md} {
    font-size: 1.125rem;
  }

  display: flex;
  justify-content: flex-end;

  ${ProductContent} & {
    flex: 1;
  }
`
export const ProductName = styled(OrdersUI.ProductName)`
  color: inherit;
  margin: 0;

  & > * {
    margin: 0;
  }

  &:hover {
    color: ${theme.colors.primary};
  }
`

export const StickyInfoWrapper = styled.div`
  width: 100%;
  position: sticky;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  gap: 10px;

  top: unset;

  @media ${media.md} {
    top: calc(var(--header-height-desktop) + 20px);
  }
`

export const TotalInfo = styled(OrdersUI.TotalInfo)`
  border: unset;
  padding: unset;
`

export const TotalInfoTitle = styled.div`
  font-weight: bold;
  font-size: 1.25rem;
`

export const Info = styled(OrdersUI.InfoRow)`
  min-width: 0;
  width: 100%;
  position: sticky;
  padding: 20px;

  align-items: center;

  bottom: var(--header-height-mobile);

  @media ${media.md} {
    min-width: 320px;
    width: unset;
    padding: unset;
    position: relative;
    bottom: unset;
    align-items: unset;
  }
`

export const Actions = styled(OrdersUI.Actions)`
  width: 100%;
  
  .ant-alert {
    white-space: normal;
  }
`

export const BuyButton = styled(OrdersUI.BuyButton)`
  width: 100%;

  span {
    font-size: 1.125rem;
  }
`

export const RemoveItem = styled.div`
  display: flex;
  gap: 8px;
  cursor: pointer;

  position: absolute;
  top: 15px;
  right: 15px;

  @media ${media.lg} {
    position: relative;

    top: unset;
    right: unset;
  }
`

export const ProductPrice = styled(OrdersUI.ProductPrice)`
  padding: unset;
`

export const BasketEmpty = styled.h3`
  padding: 20px 0;

  ${CollapseUI.ListItemContent} & {
    padding-bottom: 20px;
  }
`

export const Prices = styled.span`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`


export const ShowcaseProducts = styled.div`
  padding-top: 20px;
`

export const ShowcaseProductsTitle = styled.div`
  font-size: 1.35rem;
  font-weight: 450;
`